module.exports = __webpack_public_path__ + "static/media/KW13_AS1.79a87e6b.JPG";